/**
 * Guest-transcription token. Callers must only create/send it when the
 * NEXT_PUBLIC_FEATURE_GUEST_TRANSCRIPTION flag is enabled.
 *
 * Same key as the dashboard (ЛК) — landing and app share one domain, so the token
 * written here in localStorage is read back by the guest ЛК after redirect. The token
 * is not put in navigation URLs — редирект в ЛК несёт только `guest=true`.
 * Upload init requests send it in `x-guest-token`; multipart `/s3-upload`
 * part proxy URLs also include it as the nginx auth token so backend can sign
 * `multipart/user_*` uploads for already materialized guests.
 */
export const GUEST_TOKEN_KEY = "transcripta_guest_token";

/**
 * Returns the existing guest token, generating and persisting a new one
 * (crypto.randomUUID) on first call. No-op (returns null) outside the browser.
 * Idempotent — repeat uploads reuse the same token.
 */
export function ensureGuestToken(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const existing = window.localStorage.getItem(GUEST_TOKEN_KEY);
    if (existing) return existing;
    const token = crypto.randomUUID();
    window.localStorage.setItem(GUEST_TOKEN_KEY, token);
    return token;
  } catch {
    return null;
  }
}

/** Reads the current guest token without generating one. */
export function getGuestToken(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(GUEST_TOKEN_KEY);
  } catch {
    return null;
  }
}
